import React from 'react';

const NoMatch = () => (
  <div>
    <h2>404 - Page Not Found</h2>
  </div>
);

export default NoMatch;
